import { defineComponent as _defineComponent } from 'vue'
import { reactive, computed, ref } from "vue";
  import useVuelidate from "@vuelidate/core";
  import { numeric, required } from "@vuelidate/validators";
  import store from "@/store";
  import router from "@/router";
  import { CreateStageMapInterface } from "@/types/CreateStageMapInterface";
  import { isPngType, isValidFileSize } from "@/helpers/fileUpload";
  import { useToast } from "vue-toastification";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminStageMapCreate',
  setup(__props, { expose: __expose }) {
  __expose();

  const userId = router.currentRoute.value.params.userId as string;
  const estateId = router.currentRoute.value.params.estateId as string;
  const stageId = router.currentRoute.value.params.stageId as string;
  const form = reactive({
    width: 0,
    height: 0,
    x: 0,
    y: 0,
    path: "",
    file: null,
  });
  const rules = computed(() => {
    return {
      width: { required, numeric, $autoDirty: true },
      height: { required, numeric, $autoDirty: true },
      x: { required, numeric, $autoDirty: true },
      y: { required, numeric, $autoDirty: true },
      path: { required, $autoDirty: true },
      file: { required },
    };
  });
  const v$ = useVuelidate(rules, form);
  const loading = ref(false);
  const toast = useToast();

  function selectFile(e: any) {
    if (!e.target.files.length) {
      return;
    }

    const selectedFile = e.target.files[0];

    if (!isPngType(selectedFile) || !isValidFileSize(selectedFile)) {
      return;
    }

    form.file = selectedFile;
  }
  function uploadFile() {
    const data = new FormData();

    data.append("file", form.file as File);
    const payload = {
      landownerId: userId,
      estateId,
      stageId,
      data,
    };

    return store.dispatch("stage/uploadStageMapImg", payload);
  }
  async function createMap() {
    v$.value.$touch();
    const isFormCorrect = await v$.value.$validate();

    if (!isFormCorrect) return;

    loading.value = true;
    uploadFile()
      .then((res) => {
        const data: CreateStageMapInterface = {
          landownerId: userId,
          estateId,
          stageId,
          mapImage: res.data,
          size: {
            width: form.width,
            height: form.height,
          },
          path: form.path,
          binding: {
            x: form.x,
            y: form.y,
          },
        };

        store
          .dispatch("stage/createStageMap", data)
          .then(() => {
            router.push({
              name: "AdminStageMap",
              params: { userId, estateId, stageId },
            });
          })
          .catch(() => {
            loading.value = false;
            toast.error("Something went wrong");
          });
      })
      .catch(() => {
        loading.value = false;
        toast.error("Something went wrong");
      });
  }

const __returned__ = { userId, estateId, stageId, form, rules, v$, loading, toast, selectFile, uploadFile, createMap, reactive, computed, ref, get useVuelidate() { return useVuelidate }, get numeric() { return numeric }, get required() { return required }, get store() { return store }, get router() { return router }, get CreateStageMapInterface() { return CreateStageMapInterface }, get isPngType() { return isPngType }, get isValidFileSize() { return isValidFileSize }, get useToast() { return useToast } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})